import { Button } from "@sellar-io/components";
import {
  FulfillmentTypeContainerDeliveryChargeUpdateRequestType,
  FulfillmentTypeListResponseType,
} from "@sellar-io/api-v2/types";
import { useId } from "react";
import { useForm } from "react-hook-form";
import { Alert } from "../../../../components/alert/Alert";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../../components/modal/Dialog";
import { apiV2AssertError } from "../../../../hooks/api/v2/apiV2Request";
import { useFulfillmentTypeContainerDeliveryChargeDelete } from "../../../../hooks/api/v2/fulfillmentTypeContainerDeliveryCharge/useFulfillmentTypeContainerDeliveryChargeDelete";
import { useFulfillmentTypeContainerDeliveryChargeUpdate } from "../../../../hooks/api/v2/fulfillmentTypeContainerDeliveryCharge/useFulfillmentTypeContainerDeliveryChargeUpdate";
import { FulfillmentTypeContainerDeliveryChargeForm } from "../forms/FulfillmentTypeContainerDeliveryChargeForm";

export const FulfillmentTypeContainerDeliveryChargeUpdateDialog = ({
  active,
  onDismiss,
  fulfillmentTypeContainerDeliveryCharge,
}: {
  active: boolean;
  onDismiss: () => void;
  fulfillmentTypeContainerDeliveryCharge: FulfillmentTypeListResponseType[number]["FulfillmentTypeContainerDeliveryCharges"][number];
}) => {
  const form = useForm<FulfillmentTypeContainerDeliveryChargeUpdateRequestType>(
    {
      shouldUseNativeValidation: true,
      defaultValues: {
        volume: fulfillmentTypeContainerDeliveryCharge.volume,
        packQuantity: fulfillmentTypeContainerDeliveryCharge.packQuantity,
        displayUnit: fulfillmentTypeContainerDeliveryCharge.displayUnit,
        containerType: fulfillmentTypeContainerDeliveryCharge.containerType,
        charge: fulfillmentTypeContainerDeliveryCharge.charge / 100,
      },
    },
  );
  const formId = useId();

  const FulfillmentTypeContainerDeliveryChargeUpdateMutation =
    useFulfillmentTypeContainerDeliveryChargeUpdate(
      fulfillmentTypeContainerDeliveryCharge.id,
    );
  const FulfillmentTypeContainerDeliveryChargeDeleteMutation =
    useFulfillmentTypeContainerDeliveryChargeDelete(
      fulfillmentTypeContainerDeliveryCharge.id,
    );

  const onDelete = () => {
    FulfillmentTypeContainerDeliveryChargeDeleteMutation.mutate();
    onDismiss();
  };
  const onSubmit = (
    data: FulfillmentTypeContainerDeliveryChargeUpdateRequestType,
  ) => {
    FulfillmentTypeContainerDeliveryChargeUpdateMutation.mutate(
      {
        volume: parseFloat(data.volume.toString()),
        packQuantity: parseInt(data.packQuantity.toString()),
        displayUnit: data.displayUnit,
        containerType: data.containerType,
        charge: parseInt((parseFloat(data.charge.toString()) * 100).toString()),
      },
      {
        onSuccess: () => onDismiss(),
      },
    );
  };
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        title={"Update delivery charge"}
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
      />
      <DialogContent>
        {FulfillmentTypeContainerDeliveryChargeUpdateMutation.isError ? (
          <Alert
            type={"error"}
            message={
              apiV2AssertError(
                FulfillmentTypeContainerDeliveryChargeUpdateMutation.error,
              )?.response?.data.message ?? "Unknown error occurred."
            }
          />
        ) : null}
        <FulfillmentTypeContainerDeliveryChargeForm
          form={form}
          onSubmit={onSubmit}
          formId={formId}
        />
      </DialogContent>
      <DialogCTA>
        <Button color={"red"} onClick={() => onDelete()}>
          Delete
        </Button>
        <Button
          type="submit"
          form={formId}
          loading={
            FulfillmentTypeContainerDeliveryChargeUpdateMutation.isPending
          }
        >
          Update
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
